import { getCurrentLanguage } from 'utils/app/get-lang';
import { EAccountRouteKeys } from 'constants/account/account-route-keys';
import { ViewModes } from 'interfaces';

const API_URL_BY_VIEW_MODE = {
  [ViewModes.DEFAULT]: 'https://api.ftnft.com',
  [ViewModes.KIOSK]: 'https://api.ftnft.com',
  [ViewModes.FTNFT_AM]: 'https://api.ftnft.am',
  [ViewModes.KIOSK_AM]: 'https://api.ftnft.am',
  [ViewModes.KIOSK_VENICE]: 'https://api.ftnft.com'
};

/* eslint-disable */
export const Configs = {
  /*  Backend  */

  API_URL:
    window.partnerConfigs?.apiUrl ||
    API_URL_BY_VIEW_MODE[window.partnerConfigs?.viewMode || ViewModes.DEFAULT],

  /*  Page  */
  LANGUAGE: getCurrentLanguage('long') || 'en-us',
  LANGUAGE_PREFIX: getCurrentLanguage('short') || 'en',
  USER_FILES_URL: window?.partnerConfigs?.userFilesUrl || '',

  /*  Payment  */
  CART_ENABLED: window?.partnerConfigs?.cartEnabled || false,

  /*  3rd party integrations  */
  IS_CONNECT_METAMASK_AVAILABLE:
    window.partnerConfigs?.metamaskIntegration || true,
  MARKETPLACE_WALLET_ADDRESS: '0x5516d8f2C1b8763dB878474046f2Add18980CC18',

  /*  Views  */
  VIEW_MODE: window.partnerConfigs?.viewMode || ViewModes.DEFAULT,

  /*  DateTime  */
  DATE_FORMAT: 'MMM DD, YYYY',
  TIME_FORMAT: 'HH:mm',
  DATE_TIME_FORMAT: 'MMM DD, YYYY HH:mm',

  /*  Miscellaneous  */
  MOCKED_DATA: window?.mockedData || false,

  /*  Routing  */
  PAGE_URLS: {
    EXPLORE: window.partnerConfigs?.nftsPagePath || '/',
    LOGIN: window.partnerConfigs?.loginPagePath,
    REGISTER: window.partnerConfigs?.registerPagePath
  },
  PROTECTED_ROUTES: {
    [EAccountRouteKeys.ACCOUNT_PROFILE as string]: {
      exclude: [EAccountRouteKeys.ACCOUNT_PROFILE_WALLET_CALLBACK as string]
    }
  },
  BLOCK_BUY_SELL: window.partnerConfigs?.blockBuySell || window.partnerConfigs?.viewMode === ViewModes.DEFAULT || false
};

export const IS_DEFAULT_MODE = Configs.VIEW_MODE === ViewModes.DEFAULT;
export const IS_KIOSK_MODE = Configs.VIEW_MODE === ViewModes.KIOSK;
export const IS_FTNFT_AM_MODE = Configs.VIEW_MODE === ViewModes.FTNFT_AM;
export const IS_KIOSK_AM_MODE = Configs.VIEW_MODE === ViewModes.KIOSK_AM;
export const IS_KIOSK_VENICE_MODE =
  Configs.VIEW_MODE === ViewModes.KIOSK_VENICE;
export const IS_KIOSK_GENERIC =
  IS_KIOSK_MODE || IS_KIOSK_AM_MODE || IS_KIOSK_VENICE_MODE;
/* eslint-enable */
